import React from "react";
import {formatCurrency} from "../../utils/format";

type StrategyAccordionHeaderProps = {
    description: string,
    type: string,
    amountToBeneficiaries: number | string,
    impactToEstEstateTax: number,
    isInReportPreview: boolean,
    enabled: boolean
};

export function StrategyAccordionItemHeader({
                                                description,
                                                type,
                                                amountToBeneficiaries,
                                                impactToEstEstateTax,
                                                enabled,
                                                isInReportPreview
                                            }: StrategyAccordionHeaderProps) {
    return (
        <div>
            {
                <div className={isInReportPreview ? "strategy-accordion-item__report" : "strategy-accordion-item__web"}>
                    <span className={enabled ? "span-1-enabled" : "span-1-disabled"}>{description}</span>
                    <span className={enabled ? "span-2-enabled" : "span-2-disabled"}>{type}</span>
                    {typeof amountToBeneficiaries === "string" &&
                        <span className={"span-3-disabled textalign-right"}>{amountToBeneficiaries}</span>}
                    {typeof amountToBeneficiaries === "number" &&
                        <span
                            className={enabled ? "span-3-enabled textalign-right" : "span-3-disabled textalign-right"}>{formatCurrency(amountToBeneficiaries)}</span>}
                    <span
                        className={enabled ? "span-4-enabled textalign-right" : "span-4-disabled textalign-right"}>{formatCurrency(impactToEstEstateTax)}
                    </span>
                </div>
            }
        </div>
    );
}